import StencilHTMLElement from "./stencil-element";

class MetaobjectList extends StencilHTMLElement {
  defer = false;
  type;
  sortKey;
  filters;
  metaobjects = [];
  templates = {};
  grid;

  constructor() {
    super();
  }

  connectedCallback() {
    this.defer = this.getAttribute('defer') === 'true';
    this.type = this.getAttribute("type");
    this.sortKey = this.getAttribute("sort-key");

    this.filters = this.querySelector("metaobject-list-filters");
    this.grid = this.querySelector(".metaobject-grid");

    this.templates = Object.fromEntries(
      [...this.querySelectorAll(":scope > template")].map(template => [template.id, template])
    );

    Stencil.PostInitCallbacks.push(this.init.bind(this));

    document.addEventListener("shopify:section:load", e => {
      if(this.closest(".shopify-section").id.includes(e.detail.sectionId)){
        console.log(this.logPrefix, 'Section changed!');
        this.init();
      }
    });
  }

  async init() {
    if(!this.defer) return;
    this.metaobjects = await Stencil.Helpers.getMetaobjects(this.type, this.sortKey);

    this.metaobjects.forEach(metaobject => {
      // Filter and transform data attributes
      let dataAttributes = [];
      if(this.filters){
        dataAttributes = Object.entries(metaobject.fields_keyed)
          .filter(([fieldKey]) => this.filters.definitions.some(filter => filter.field_key === fieldKey))
          .map(([fieldKey, value]) => {
            try {
              value = JSON.parse(value.resolved_value).join(',');
            } catch {
              value = value.resolved_value;
            }
            return { key: fieldKey, value };
          });
      }
      // Clone and populate the template
      const clone = this.templates["template-card-metaobject"].content.cloneNode(true);
      const metaobjectElement = clone.querySelector('.card-metaobject');

      dataAttributes.forEach(({ key, value }) => {
        const datasetKey = `metaobject${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        metaobjectElement.dataset[datasetKey] = value;
      });

      // Set title
      clone.querySelector('h5').textContent = metaobject.fields_keyed.title.resolved_value;

      // Append the clone to the container
      this.grid.appendChild(clone);
    });

    if(this.filters){
      this.filters.populate(this.metaobjects);
    }
  }
}

export default MetaobjectList;